import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container } from './ui';

const StyledVideo = styled.section`
  ${sectionMargins()};
`;

const StyledVideoElement = styled.video`
  max-width: 100%;
`;

const Video = ({ url }) => (
  <StyledVideo>
    <Container narrow={true}>
      <StyledVideoElement
        controls={true}
        muted={true}
        autoPlay={true}
        playsInline={true}
      >
        <source src={url} type="video/mp4" />
      </StyledVideoElement>
    </Container>
  </StyledVideo>
);

export default Video;
